export default __webpack_public_path__ + "static/media/elpis-planet.9abb4bf9.png";